export const WELCOME_MSG = 'Welcome to Beijing Huixinjunda Intellectual Property Agency Co., Ltd.';
export const SLOGON_LINE1 = 'Create Value Via';
export const SLOGON_LINE2 = 'Intellectual Property';
export const MENU_DATA = [
    {
        name: 'Home',
        path: '/',
        active: true,
    },
    {
        name: 'Scope of Services',
        path: 'service',
        active: false,
    },
    {
        name: 'Experience',
        path: 'experience',
        active: false,
    },
    {
        name: 'About Us',
        path: 'aboutUs',
        active: false,
    },
    {
        name: 'Team and Consultants',
        path: 'team',
        active: false,
    },
    {
        name: 'Contact Us',
        path: 'contact',
        active: false,
    },
    // {
    //     name: 'Recruitment Information',
    //     path: 'hire',
    //     active: false,
    // },
];
export const SCOPE_OF_SERVICES = {
    section_title: 'Scope of Services',
    desc: 'Huixinjunda specializes in providing customers with commercial solutions using intellectual property as a tool, establishing three service segments of rights acquisition, dispute resolution and business consulting. Help customers unlock maximum value in product innovation, market development, investment and financing.',
    acquire_intellectual_property: {
        title: 'Acquire IP right',
        content_lines: [
            'Patent Applications',
            'Patent Reexamination and Invalidation',
            'Patent Infringement Litigation',
            'Trademark registration consultation and search',
            'Trademark monitoring and issuance of monitoring reports',
            'Trademark administrative litigation case agency business',
        ],
    },
    dispute_resolution: {
        title: 'Dispute resolution',
        content_lines: [
            'Patent invalidation and administrative litigation',
            'Trademark invalidation and administrative litigation',
            'Patent and trademark infringement disputes',
            'Trade secret infringement disputes',
            'Online rights protection',
            'Intellectual property ownership disputes',
        ],
    },
    business_consulting_services: {
        title: 'Business consulting',
        content_lines: [
            'Patent Infringement Search and Analysis',
            'Due Diligence Before Equity Investment',
            'Technical investigation and technical tracking',
            'Cross-border technology transaction of pharmaceutical and medical devices',
            'Technology project investment and financing services',
            'Intellectual property transfer and licensing',
        ],
    },
};
export const EXCEPTIONNAL_INDUSTRY_EXPERIENCE = {
    section_title: 'Experience',
    desc: "Huixinjunda's customer fields cover: automatic driving and new energy vehicles, medical equipment, drug discovery and development, industrial software, cyber security, industrial robotics, education, consumer electronics, new materials, new energy, financial investment",
};
// 多维数组，一页是一组，一组显示8个
export const COMPANY_INFO = [
    [
        {
            name: 'XPeng Motors',
            image: require('@/assets/images/company/xiaopengqiche.png'),
            logo: require('@/assets/images/company/xiaopengqichelogo.png'),
            desc: 'A manufacturer of smart electric vehicles',
        },
        {
            name: 'RoboSense',
            image: require('@/assets/images/company/suteng.png'),
            logo: require('@/assets/images/company/sutenglogo.png'),
            desc: 'Provide sensors and solutions applied in the fields of vehicle-mounted and robotics',
        },
        {
            name: 'SFMap Technology',
            image: require('@/assets/images/company/fengtukeji.png'),
            logo: require('@/assets/images/company/fengtulogo.png'),
            desc: 'Spatio-temporal big data services, build smart transportation and digital twin solutions',
        },
        {
            name: 'Mogo.ai',
            image: require('@/assets/images/company/moguchelian.png'),
            logo: require('@/assets/images/company/moguchelianlogo.png'),
            desc: 'A provider of full-stack technologies and operation services for vehicle-road-cloud integrated autonomous driving',
        },
        {
            name: 'Idriverplus',
            image: require('@/assets/images/company/zhixing.png'),
            logo: require('@/assets/images/company/zhixinglogo.png'),
            desc: 'A service provider of overall autonomous driving solutions',
        },
        {
            name: 'MiracoMotor',
            image: require('@/assets/images/company/qiji.png'),
            logo: require('@/assets/images/company/qijilogo.png'),
            desc: 'A supplier of new energy commercial vehicle solutions under GAC Group',
        },
        {
            name: 'XPENG AEROHT',
            image: require('@/assets/images/company/xiaopenghuitian.png'),
            logo: require('@/assets/images/company/xiaopenghuitianlogo.png'),
            desc: 'Intelligent electric flying car solution',
        },
        {
            name: 'RealAI',
            image: require('@/assets/images/company/ruilai.png'),
            logo: require('@/assets/images/company/ruilailogo.png'),
            desc: 'A provider of safe and controllable artificial intelligence systems and a provider of third-generation artificial intelligence infrastructure and solutions',
        },
    ],
    [
        {
            name: 'Shengshu Technology',
            image: require('@/assets/images/company/shengshu.png'),
            logo: require('@/assets/images/company/shengshulogo.png'),
            desc: 'Builder of generative artificial intelligence infrastructure and applications',
        },
        {
            name: 'PERA Global',
            image: require('@/assets/images/company/anshiyatai.png'),
            logo: require('@/assets/images/company/anshiyatailogo.png'),
            desc: 'A developer of new industrial products, and a founder of enterprise simulation systems and lean research and development systems',
        },
        {
            name: 'DeepVision Technology',
            image: require('@/assets/images/company/shendushijue.png'),
            logo: require('@/assets/images/company/shendushijuelogo.png'),
            desc: 'A high-tech enterprise integrating multiple technologies such as machine vision, computer image processing and artificial intelligence technology',
        },
        {
            name: 'Sangfor',
            image: require('@/assets/images/company/shenxinfu.png'),
            logo: require('@/assets/images/company/shenxinfulogo.png'),
            desc: 'A product and service provider focusing on enterprise-level network security, cloud computing and IT infrastructure',
        },
        {
            name: 'QAX',
            image: require('@/assets/images/company/qianxin.png'),
            logo: require('@/assets/images/company/qianxinlogo.png'),
            desc: "A leader in China's enterprise-level network security market",
        },
        {
            name: 'Neural Galaxy',
            image: require('@/assets/images/company/younao.png'),
            logo: require('@/assets/images/company/younaologo.png'),
            desc: 'A supplier of brain science technologies',
        },
        {
            name: 'XtalPi',
            image: require('@/assets/images/company/jingtai.png'),
            logo: require('@/assets/images/company/jingtailogo.png'),
            desc: 'An intelligent and automated-driven pharmaceutical research and development technology company',
        },
        {
            name: 'Chemclin Diagnostics',
            image: require('@/assets/images/company/kemei.png'),
            logo: require('@/assets/images/company/kemeilogo.png'),
            desc: 'A provider of chemiluminescence diagnostic detection solutions for clinical immunology',
        },
    ],
    [
        {
            name: 'METiS',
            image: require('@/assets/images/company/jitai.png'),
            logo: require('@/assets/images/company/jitailogo.png'),
            desc: 'An innovative biotechnology company that conducts drug research and development through artificial intelligence-driven and precisely targeted drug delivery and drug discovery technologies',
        },
        {
            name: 'Biometa',
            image: require('@/assets/images/company/bainuo.png'),
            logo: require('@/assets/images/company/bainuologo.png'),
            desc: 'A one-stop CRDMO enabling service provider covering the whole process from research and development to commercialization in multiple fields of biopharmaceuticals',
        },
        {
            name: 'Insight Medtech',
            image: require('@/assets/images/company/beixin.png'),
            logo: require('@/assets/images/company/beixinlogo.png'),
            desc: 'A provider of high-end interventional and implantable medical devices',
        },
        {
            name: 'Easpring',
            image: require('@/assets/images/company/dangsheng.png'),
            logo: require('@/assets/images/company/dangshenglogo.png'),
            desc: 'A professional supplier of cathode materials for lithium-ion batteries',
        },
        {
            name: 'HAI ROBOTICS',
            image: require('@/assets/images/company/hairou.png'),
            logo: require('@/assets/images/company/hairoulogo.png'),
            desc: 'A provider of box storage robot solutions',
        },
        {
            name: 'HongMen Technology',
            image: require('@/assets/images/company/hongmen.png'),
            logo: require('@/assets/images/company/hongmenlogo.png'),
            desc: 'A world-leading provider of intelligent security solutions',
        },
        {
            name: 'GreenDisplay',
            image: require('@/assets/images/company/zhihui.png'),
            logo: require('@/assets/images/company/zhihuilogo.png'),
            desc: 'A provider of digital, zero-emission and wireless display integrated solutions',
        },
        {
            name: 'NOVOSHINE',
            image: require('@/assets/images/company/yuanxu.png'),
            logo: require('@/assets/images/company/yuanxulogo.png'),
            desc: 'Research and development of semiconductor optoelectronic materials and chip products',
        },
    ],
    [
        {
            name: 'Jingying',
            image: require('@/assets/images/company/jingying.png'),
            logo: require('@/assets/images/company/jingyinglogo.png'),
            desc: 'A provider of software solutions that use digital technology to achieve intelligent, efficient and safe operation of mines',
        },
        {
            name: 'Highpower Technology',
            image: require('@/assets/images/company/haopeng.png'),
            logo: require('@/assets/images/company/haopenglogo.png'),
            desc: 'A provider of solutions for the research and development of lithium-ion batteries and nickel-metal hydride batteries, as well as the recycling of used batteries and the recycling of resources',
        },
        {
            name: 'Feihu Interactive',
            image: require('@/assets/images/company/feihu.png'),
            logo: require('@/assets/images/company/feihulogo.png'),
            desc: 'The pioneer and leader of remote banking services, dedicated to researching the in-depth scenario-based application of interactive video + AI technology in the financial industry',
        },
        {
            name: 'SmartMi',
            image: require('@/assets/images/company/zhimi.png'),
            logo: require('@/assets/images/company/zhimilogo.png'),
            desc: 'An intelligent hardware company dedicated to the design innovation and research and development of intelligent household electrical products',
        },
        {
            name: 'Usmile',
            image: require('@/assets/images/company/meirong.png'),
            logo: require('@/assets/images/company/meironglogo.png'),
            desc: 'A provider that perfectly integrates technological aesthetics and usage efficacy into the full range of oral care products',
        },
        {
            name: 'SoYoung',
            image: require('@/assets/images/company/xinyang.png'),
            logo: require('@/assets/images/company/xinyanglogo.png'),
            desc: 'A leading domestic medical beauty and medical service industry group, providing one - stop "big health" services',
        },
        {
            name: 'LingDu Capital',
            image: require('@/assets/images/company/lingdu.png'),
            logo: require('@/assets/images/company/lingdulogo.png'),
            desc: 'A professional investment management company that conducts private equity investment, enterprise mergers and acquisitions and restructuring, as well as entrepreneurship service business',
        },
        {
            name: 'Saky',
            image: require('@/assets/images/company/shuke.png'),
            logo: require('@/assets/images/company/shukelogo.png'),
            desc: 'Provide professional solutions for various oral problems',
        },
    ],
    [
        {
            name: 'SKG',
            image: require('@/assets/images/company/skg.png'),
            logo: require('@/assets/images/company/skglogo.png'),
            desc: 'A high-tech enterprise dedicated to providing intelligent wearable health products for individuals and families',
        },
        {
            name: 'China Sports Lottery',
            image: require('@/assets/images/company/tiyu.png'),
            logo: require('@/assets/images/company/tiyulogo.png'),
            desc: 'National sports lottery issuance and management',
        },
        {
            name: 'DaDa Group',
            image: require('@/assets/images/company/dada.png'),
            logo: require('@/assets/images/company/dadalogo.png'),
            desc: "China's leading local instant retail and delivery platform",
        },
    ],
];

export const TEAM_INFO = [
    {
        name: 'Chen Li',
        desc1: 'Partner；Patent attorney；Technology broker',
        desc2: 'Member of the expert database of Beijing IP Office',
        image: require('@/assets/images/team/李辰.png'),
        position: ['Telecommunications Engineering and Electronic Technology', 'IP operation and negotiation'],
    },
    {
        name: 'Qifa Huang',
        desc1: 'Partner；Patent attorney',
        image: require('@/assets/images/team/黄启法.png'),
        position: [
            'Telecommunications Engineering',
            'Once worked in Alibaba',
            'Autonomous driving and intelligent vehicles',
        ],
    },
    {
        name: 'Shuzhen Liu',
        desc1: 'Partner；Patent attorney',
        image: require('@/assets/images/team/刘淑珍.png'),
        position: [
            'Telecommunications Engineering；Software Engineering；Optical Science',
            'Dual background in science and engineering and law',
        ],
    },
    {
        name: 'Lijuan Mu',
        desc1: 'Partner；Process supervisor',
        image: require('@/assets/images/team/慕丽娟.png'),
        position: [
            'With more than 10 years of experience in patent process management',
            'Familiar with patent procedures in major countries and regions in China and abroad',
        ],
    },
    {
        name: 'Wenliang Xu',
        desc1: 'Patent attorney；Lawyer',
        image: require('@/assets/images/team/许文亮.png'),
        position: [
            'Five years of research and development experience',
            'Industrial Robot',
            'Patent retrieval and FTO analysis',
            'Representative clients: XPeng Motors, RoboSense, and Hai Robotics',
        ],
    },
    {
        name: 'Xiangfei Liu',
        desc1: 'Partner；Patent attorney',
        image: require('@/assets/images/team/刘湘菲.png'),
        position: [
            'Computer-aided drug research and development',
            'Digitalization of the new materials industry',
            'Consumer electronics',
            'Representative clients: XtalPi, Chemclin Diagnostics, METiS etc',
        ],
    },
    {
        name: 'Mengqian Li',
        desc1: 'Partner；Patent attorney',
        image: require('@/assets/images/team/李梦倩.png'),
        position: [
            'Master of Materials Engineering',
            'Technology layout of IVD microfluidic chips and protein drug',
            'Representative clients: Chemclin Diagnostics, XtalPi',
            'FTO analysis of consumer products',
        ],
    },
    {
        name: 'Caixun Ye',
        desc1: 'Patent Engineer',
        image: require('@/assets/images/team/叶才勋.png'),
        position: [
            'Autonomous driving, visual artificial intelligence',
            'Patent retrieval and analysis',
            'Patent mining and layout',
            'Representative clients: Mogo.ai, PERA Global',
        ],
    },
    {
        name: 'Xiaojia Lin',
        desc1: 'Patent Engineer',
        image: require('@/assets/images/team/林晓嘉.png'),
        position: [
            'High-end equipment and power batteries',
            'Representative clients: Sunwoda Battery, Highpower Battery, Hisense, Kingfa Sci. & Tech., Dongguan Deki Precision Industry Co., Ltd., Hai Robotics.',
        ],
    },
    {
        name: 'Fang Lin',
        desc1: 'Patent Engineer；Biological engineering',
        image: require('@/assets/images/team/林芳.png'),
        position: [
            'Due diligence on IP in the field of medical devices and pharmaceuticals',
            'Representative clients: InnovGene, Insight Medtech, Chemclin Diagnostics',
        ],
    },
    {
        name: 'zhihong Liu',
        desc1: 'Patent Engineer',
        image: require('@/assets/images/team/刘志红.png'),
        position: [
            'Automation and software security',
            'Engaged in intellectual property work since 2012',
            'Representative clients: Lenovo, iQIYI, Samsung Electronics, Bank of China, Agricultural Bank of China',
        ],
    },
    {
        name: 'Xuelian Zhu',
        desc1: 'Patent Engineer',
        image: require('@/assets/images/team/朱雪莲.png'),
        position: [
            'Mobile communication,artificial intelligence',
            'Representative clients: BYD, Inspur Suzhou, SoYoung, XPeng Motors, VISIONVERA, Datang Mobile',
        ],
    },
    {
        name: 'Junhao Wang',
        desc1: 'Patent attorney',
        image: require('@/assets/images/team/王俊豪.png'),
        position: [
            'with experience in mechanical research and design',
            'Main fields: automobiles, new energy vehicles, medical devices',
            'Representative clients: GAC R&D Center, Guangqi Honda, Rifeng Group, Chemclin Diagnostics, Kingfa Sci. & Tech',
        ],
    },
    {
        name: 'Bitian Wang',
        desc1: 'Patent Engineer',
        image: require('@/assets/images/team/王弼天.png'),
        position: [
            'Telecommunications Engineering',
            'Focused fields: blockchain, artificial intelligence',
            'Proficient in patent rejection review',
            'Representative clients: Mogo.ai, XPeng Motors, Hunan Blockchain Laboratory',
        ],
    },
    {
        name: 'Si Chen',
        desc1: 'Patent attorney；Lawyer',
        image: require('@/assets/images/team/陈思.png'),
        position: [
            'New energy vehicles, automotive electronics',
            'Representative clients: XPeng Motors, FiberHome Communications, Wuhan Jingce Electronic Group Co., Ltd., Dongfeng Motor Corporation, Voyah',
        ],
    },
    {
        name: 'Shuxian Ran',
        desc1: 'Patent engineer',
        image: require('@/assets/images/team/冉淑贤.png'),
        position: [
            'Majoring in software engineering',
            'Once served in Great Wall Motor',
            'Possessing rich experience in freedom to operate (FTO) analysis and invalidity analysis',
            'Representative clients: SmartMi, PERA Global, Mogo.ai, RealAI and other large enterprises',
        ],
    },
    {
        name: 'Yiwen Niu',
        desc1: 'Partner, patent attorney',
        image: require('@/assets/images/team/牛艺文.png'),
        position: [
            'Member of the expert database of Beijing Intellectual Property Office',
            'Technology broker',
            'Expert of the national intellectual property operation pilot platform',
            'Industrial automation and high-end equipment',
        ],
    },
    {
        name: 'Wanqin Yuan',
        desc1: 'Patent engineer',
        image: require('@/assets/images/team/袁婉芹.png'),
        position: [
            'Mobile communication, autonomous driving, artificial intelligence',
            'Representative clients: BYD, Inspur Suzhou, SoYoung, XPeng Motors, Datang Mobile',
        ],
    },
    {
        name: 'Qingwen Lu',
        desc1: 'Patent engineer',
        image: require('@/assets/images/team/陆清文.png'),
        position: [
            'Electronic information science and technology',
            'Focused fields: mobile communication, autonomous driving, artificial intelligence',
            'Representative clients: Alibaba, China Telecom, BYD, XPeng Motors, Datang Mobile, PERA Global',
        ],
    },
    {
        name: 'Caiyun Chen',
        desc1: 'Trademark agent',
        image: require('@/assets/images/team/陈彩云.png'),
        position: [
            'Started to engage in trademark work in 2009,Rich practical experience in trademarks,Responsible for providing trademark consulting services to enterprises',
        ],
    },
    {
        name: 'Hongsheng Huang',
        desc1: 'Patent attorney',
        image: require('@/assets/images/team/黄红胜.png'),
        position: [
            'Electronic information technology',
            'Autonomous driving, in-vehicle electronics',
            'Representative clients: Dongfeng Honda, Mogo.ai, XPeng Motors, Highpower Group, PERA Global',
        ],
    },
    {
        name: 'Cuiqin Hu',
        desc1: 'Consultant lawyer',
        image: require('@/assets/images/team/胡翠琴.png'),
        position: [
            "One of “China's top 200 outstanding IP lawyers 2021”",
            'One of the "80 IP elite lawyers under 50 in China 2023"',
            'Cases selected as typical cases by courts and CNIPA',
            'Clients: ByteDance, Baidu, Chemclin Diagnostics, China Sports Lottery',
        ],
    },
    {
        name: 'Longgen Chen',
        desc1: 'Trademark agent',
        image: require('@/assets/images/team/陈龙根.png'),
        position: [
            'Former examiner of the Trademark Office',
            'Solve key problems in brand building and brand competition',
            'Representative clients: CCTV Animation, Intime Department Store, Dada Group, JD.com, Meituan, China Sports Lottery',
        ],
    },
];

export const ABOUT_US = {
    section_title: 'About Us',
    content_lines: [
        'Huixinjunda was established in 2019, adhering to the concept of "Intellectual Property Creates Commercial Value", and has built a stable team and rich service experience in the acquisition of intellectual property rights, dispute resolution, and commercialization. It aims to help customers mine maximum value in product innovation, market development, investment and financing, so that the advantages of enterprises can be expressed through intellectual property rights.',
        "Huixinjunda's customer industries include: autonomous driving and new energy vehicles, medical apparatus, drug research and development, industrial software, cyber security, industrial robots, consumer electronics, new materials, new energy, etc.",
        'With a wide range of cooperation resources, Huixinjunda still provides assistance in technology transactions, investment and financing services, and data transaction medical apparatus registration.',
    ],
    content_team: 'Service teams are established in Beijing, Wuhan, Guangzhou and Huizhou.',
};
export const COMPANY_ADDRESS = {
    section_title: 'Company address',
    hello_msg: 'Are you ready? Then get in touch with us!',
    content_lines: [
        'Beijing: Room 2801, Block 1, Lanbao International Center, No. 3 Xidawang Road, Chaoyang District. Tel: 010-56107503',
        'Wuhan: The third floor of Office Building No. 10, Creative World, No. 16 Yezihu West Road, Hongshan District',
        'Guangzhou: Room 1901, Block T1, Huangpu Vanke Center, No.1080 Huangpu East Road, Huangpu District',
        'Huizhou: Room 1307-1308, Manhattan Plaza, No. 2 Yanda Avenue, Huicheng District, Huizhou, Guangdong Province',
    ],
    name: 'Name',
    mobile: 'Mobile',
    content: 'Content',
    submit_btn: 'Submit',
};
export const RECRUITMENT_INFORMATION = {
    section_title: 'Recruitment information',
    name: 'Domestic senior patent agent',
    desc: 'Fields: computer software, communication technology, biochemistry, mechanical and electrical Engineering',
    duty: 'Job responsibilities:',
    duty_desc:
        'Domestic patent services, including patent application writing, response to examination opinions, reexamination and invalidation, patent search and analysis, etc',
    position_require: 'Job requirements:',
    require_list: [
        '1. Have more than 3 years of working experience;',
        '2. Have strong written expression, logical thinking, and communication and collaboration abilities;',
        "3. Have a bachelor's degree or above in relevant majors from regular institutions;",
        '4. Candidates who have served domestic and foreign first-class technology enterprises and have customer certification qualifications are preferred;',
        '5. Be able to face pressure and challenges; have a sense of responsibility.',
    ],
};
export const COPY_RIGHT = '©2024 Beijing HuiXinJunDa IP Agency Co., Ltd. All right reserved Beijing ICP No.19020184';
export default {
    WELCOME_MSG,
    SLOGON_LINE1,
    SLOGON_LINE2,
    MENU_DATA,
    SCOPE_OF_SERVICES,
    EXCEPTIONNAL_INDUSTRY_EXPERIENCE,
    COMPANY_INFO,
    TEAM_INFO,
    ABOUT_US,
    COMPANY_ADDRESS,
    RECRUITMENT_INFORMATION,
    COPY_RIGHT
};
